export default __webpack_public_path__ + "static/media/brochure.eaf60db4.svg";